<template>
  <div class="eightPage" ref="qudao" v-show="qudaoShow">
    <div class="eightPage-container">
      <div class="title demibold animate__animated animate__fadeInUp">
        {{ $t("申请步骤介绍") }}
      </div>
      <div class="smallTitle regular animate__animated animate__zoomInDown">
        <span class="animate__animated animate__zoomInDown">
          {{ $t("您仅需享受最快10分钟申请 立即拥有输你的自己的WFFCard") }}
        </span>
        <br />
        <span class="animate__animated animate__zoomInDown">
          {{ $t("申请前务必核对申请条件及基础信息!") }}
        </span>
      </div>

      <div class="steps-wrapper">
        <div class="steps-background">
          <div class="bg"></div>
          <div class="colorBg animate__animated animate__zoomInRight animate__delay-1s"></div>
        </div>

        <div class="steps-container">
          <div
            class="step-item animate__animated animate__zoomInRight animate__delay-2s animate__faster"
          >
            <div class="step-image">
              <img src="@/assets/imgs/step1.png" alt="Step 1" />
            </div>
            <div class="step-text">
              {{ $t("在线会员申请，注册1分钟") }}<br />
              {{ $t("完成会员申请后开卡，开卡填写资料最长5分钟") }}
            </div>
          </div>

          <div
            class="step-item animate__animated animate__zoomInRight animate__delay-3s animate__faster"
          >
            <div class="step-image">
              <img src="@/assets/imgs/step2.png" alt="Step 2" />
            </div>
            <div class="step-text">
              {{ $t("将USDT转入钱包，增加自己的数字资产") }}<br />
              {{ $t("（请根据需求，量力而行）") }}
            </div>
          </div>

          <div
            class="step-item animate__animated animate__zoomInRight animate__delay-4s animate__faster"
          >
            <div class="step-image">
              <img src="@/assets/imgs/step3.png" alt="Step 3" />
            </div>
            <div class="step-text">
              {{ $t("步骤三") }}(<a
                href="https://card.wfh-wallet.com/opencard"
                target="_blank"
                class="step-link"
                >{{ $t("查看") }}</a
              >)
            </div>
          </div>
        </div>
      </div>

      <div class="button-wrapper">
        <el-button type="primary" class="createCard" @click="toLogin">
          {{ $t("立即开卡") }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
// import WrapBox from "./wrap/wrapBox.vue";
export default {
  name: "eightPage",
  //   components: { WrapBox },
  data() {
    return {
      qudaoShow: false,
      isAnimating: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    toLogin() {
      window.open("https://card.wfh-wallet.com/login?lang=" + this.$i18n.locale);
    },
    handleScroll() {
      let _this = this;
      _this.gdjz("qudao", 20, () => {
        _this.qudaoShow = true;
      });
    },
    gdjz(div, offset, callback) {
      let dom = this.$refs[div]; // 等同于document.querySelector('.earth') true
      if (dom) {
        var b, c, a, d;
        d = dom.offsetTop; // 元素距离相对父级的高度，这里父级指的是body
        // e = dom.offsetHeight; // 元素高度
        a = eval(d + offset);
        b =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop; //  获取窗口滚动条高度
        c = document.documentElement.clientHeight || document.body.clientHeight; // 获取浏览器可视区的高度
        if (b + c > a) {
          callback && callback();
        }
        // if (b + c > a + e) {
        //   this.qudaoShow = false;
        // }
        // if (b + c < a) {
        //   this.qudaoShow = false;
        // }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.eightPage {
  min-height: 100vh;
  background-color: #131313;
  color: #fff;
  padding: 5rem 1rem;

  &-container {
    max-width: 1400px;
    margin: 0 auto;
  }

  .title {
    font-size: clamp(28px, 5vw, 44px);
    font-weight: 700;
    line-height: 1.3;
    text-align: center;
    margin-bottom: clamp(30px, 4vw, 50px);
  }

  .smallTitle {
    font-size: clamp(16px, 2.5vw, 22px);
    font-weight: 400;
    line-height: 1.4;
    text-align: center;
    color: #fff;
    opacity: 0.8;
    padding: 0 1rem;
    max-width: 900px;
    margin: 0 auto;
  }

  .steps-wrapper {
    margin-top: clamp(50px, 8vw, 84px);
    position: relative;
  }

  .steps-background {
    position: relative;
    width: 100%;
    height: 169px;
    margin-bottom: clamp(30px, 5vw, 50px);
    border-radius: 8px;
    overflow: hidden;

    .bg {
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #353535;
      animation: move 2s forwards;
      border-radius: 8px;
    }

    .colorBg {
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.8;
      background: linear-gradient(181deg, #846d37 8.32%, #624d21 96.16%);
      border-radius: 8px;
    }
  }

  .steps-container {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    gap: 2rem;
    padding: 0 2rem;
    margin-top: -80px;
    position: relative;
    z-index: 10;
  }

  .step-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 350px;
  }

  .step-image {
    width: 100%;
    max-width: 301px;
    margin-bottom: 2rem;

    img {
      width: 100%;
      height: auto;
      display: block;
      object-fit: contain;
    }
  }

  .step-text {
    font-family: "MiSans-regular", sans-serif;
    font-size: clamp(14px, 2vw, 18px);
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    color: #fff;
    padding: 0 0.5rem;
  }

  .step-link {
    color: #f2d074;
    font-weight: 600;
    text-decoration: none;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.8;
    }
  }

  .button-wrapper {
    margin-top: clamp(50px, 8vw, 88px);
    text-align: center;
  }

  .createCard {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: min(401px, 90%);
    height: clamp(60px, 8vw, 80px);
    border-radius: 60px;
    background: linear-gradient(181deg, #846d37 8.32%, #624d21 96.16%);
    font-family: "MiSans-Demibold", sans-serif;
    font-size: clamp(18px, 2.5vw, 24px);
    font-weight: 600;
    line-height: 1.3;
    border: none;
    cursor: pointer;
    transition: transform 0.3s, box-shadow 0.3s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(132, 109, 55, 0.3);
    }
  }
}

@keyframes move {
  0% {
    opacity: 0;
    transform: translate(100%, 100%) rotate(45deg);
  }
  100% {
    opacity: 1;
    transform: rotate(3.25deg);
  }
}

// Tablet breakpoint
@media (max-width: 1024px) {
  .eightPage {
    .steps-container {
      padding: 0 1rem;
      gap: 1.5rem;
    }

    .step-image {
      max-width: 250px;
    }
  }
}

// Mobile breakpoint
@media (max-width: 768px) {
  .eightPage {
    padding: 3rem 1rem;

    &-container {
      position: relative;
    }

    .title {
      font-size: 32px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      z-index: 5;
      margin-bottom: 0;
      padding-top: 60px;
      text-align: center;
    }

    .smallTitle {
      font-size: 20px;
      position: absolute;
      top: 110px;
      left: 0;
      right: 0;
      width: 100%;
      z-index: 5;
      margin-bottom: 0;
      padding: 0 1.5rem;
      text-align: center;
    }

    .steps-wrapper {
      margin-top: 0;
      padding-top: 0;
    }

    .steps-background {
      height: 280px;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .steps-container {
      flex-direction: column;
      align-items: center;
      gap: 3rem;
      margin-top: 2rem;
      padding: 0 1rem;
    }

    .step-item {
      max-width: 100%;
      width: 100%;
    }

    .step-image {
      max-width: 200px;
      margin-bottom: 1.5rem;
    }

    .step-text {
      max-width: 400px;
      font-size: 16px;
      line-height: 1.6;
    }

    .button-wrapper {
      margin-top: 3rem;
    }

    .createCard {
      width: min(360px, 85%);
      height: 70px;
      font-size: 20px;
    }
  }
}

// Small mobile breakpoint
@media (max-width: 480px) {
  .eightPage {
    padding: 2rem 0.5rem;

    .title {
      font-size: 28px;
      padding-top: 50px;
    }

    .smallTitle {
      font-size: 18px;
      top: 95px;
    }

    .steps-background {
      height: 260px;
    }

    .step-image {
      max-width: 160px;
    }

    .step-text {
      font-size: 15px;
    }

    .steps-container {
      gap: 2rem;
    }
  }
}
</style>
